import React, { useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { useStyles } from "../../style";
import HeatMapFilterComponent from "../heatmapFilterComponent";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import HeatMapNew from "shared-component/newheatmap";
import { heatMapColorPalatte } from "utility/constants";
import HistogramIcon from "assets/histogramIcon";
import { getAggreListHeatMap } from "utility/helper";

dayjs.extend(utc);

interface HeatMapVisualizationPropTypes {
  userInputData: string[];
  updateHeatMapFilter: (value: any) => void;
  aggregateType?: any;
  setAggregateList: (value: any) => void;
}

const HeatMapVisualization = (props: HeatMapVisualizationPropTypes) => {
  const style = useStyles();
  const theme = useTheme();
  const [heatMapAPiResponse, setHeatMapAPiResponse] = React.useState<any>(null);
  const [heatMapData, setHeatMapData] = React.useState<any>(null);
  const [aggregationValue, setAggregationValue] = React.useState<string>('');
  const cDadDataVisualizationData: any = {}
  const generateDataAndLayout = async (dataItem: any) => {
    let axisData: any[] = [];
    let dataMap: any = [];
      if(dataItem?.length > 0) {
        for (const [key] of Object.entries<any>(dataItem[0])) {
          axisData.push(key)
          dataItem?.forEach((item: any) => {
            let list: any = []
            for (const [, value] of Object.entries(item)) {
              list.push(value)
            }
            dataMap.push(list)
          })
        };
      }
    const data = [{
      x: axisData,
      y: axisData,
      z: dataMap,
      type: 'heatmap',
      colorscale: heatMapColorPalatte,
    }];

    const layout = {
      width: window.innerWidth > 1350 ? 800 : 550,
      height: window.innerWidth > 1350 ? 500: 400,
      // Adjust margin to move the heatmap to the top
      margin: {
        t: 25, // Adjust this value as needed
        l: 25,
        r: 25,
        b: 25
      },
        yaxis: {
        automargin: true,
      },
      xaxis: {
        automargin: true,
      },
    };
    const heatData = {
      data, layout
    }
    setHeatMapData(heatData)
  }

  useEffect(() => {
    if(aggregationValue?.length > 0 && heatMapAPiResponse) {
      const data = heatMapAPiResponse;
      if(data?.length > 0) {
          generateDataAndLayout(data)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.aggregateType, heatMapAPiResponse])

  const generateHeatMapData = () => {
    let axisData: any = {};
    let aggList: string[] = [];
    const currentData = JSON.parse(cDadDataVisualizationData);
      if(currentData?.length > 0) {
        aggList = Object.keys(currentData[0]);
        axisData = currentData;
      }
      props.setAggregateList(getAggreListHeatMap(aggList))
      setHeatMapAPiResponse(axisData)
  }


  useEffect(() => {
    if(cDadDataVisualizationData) {
      generateHeatMapData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cDadDataVisualizationData])

  return (
    <Box>
      {cDadDataVisualizationData?.isLoading &&
        <div className={style.overlay}>
          <div className={style.loader}></div>
        </div> }
        <>
          <div
            style={{
              display: 'flex',
            }}
          ><Paper
            elevation={2}
            sx={{
              margin: "1%",
              padding: '2%',
              width: '35%'
            }}
          >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  width: '100%',
                  height: '100%'
                }}
              >
                <HeatMapFilterComponent signalList={props?.userInputData} setAggregationValue={setAggregationValue} updateHeatMapFilter={props?.updateHeatMapFilter} />
              </div>

            </Paper>
            <Paper
              elevation={2}
              sx={{
                margin: "1%",
                padding: '2%',
                width: '65%'
              }}
            >
              {heatMapData && <HeatMapNew data={heatMapData} layout={heatMapData?.layout} />}
              {!heatMapData && 
              <Box
              flex={1}
              my={2}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <HistogramIcon />
              <Typography
                variant="caption"
                textAlign={"center"}
                color={theme.palette.text.disabled}
                fontWeight={"bold"}
                width={350}
              >
                Use the  {heatMapAPiResponse ? 'Aggregation above' : 'Signal/Channel'} from dropdowns to analyse in Heat Map data chart!
              </Typography>
            </Box>
              }
            </Paper>
          </div>
        </>
    </Box>
  );
};

export default HeatMapVisualization;  